import React from "react";

import { faHotel } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import { ReactComponent as FellowWordmark } from "~/legacy-assets/images/logos/fellow-wordmark-white-solid.svg";
import Avatar from "~/ui/legacy/Avatar";

import TalkingHeads from "../components/TalkingHeads";
import type { PaneProps } from "./types";

import styles from "../css/Auth.module.css";

export default function WhitelabelPane({ account, bgStyle = "dot" }: PaneProps) {
	function renderAccountLogo() {
		if (account) {
			return (
				<Avatar
					circle
					link={false}
					width="7.5"
					user={{ id: "0", fullName: account.name ?? "", image: account.logo }}
					className={styles.workspaceLogo}
				/>
			);
		}

		return (
			<div className={cx(styles.workspaceLogo, styles.placeholder)}>
				<FontAwesomeIcon icon={faHotel}></FontAwesomeIcon>
			</div>
		);
	}

	const { invite, invite_link: inviteLink } = window.INITIAL_STATE;
	const rootDomain = window.ROOT_DOMAIN ?? ".fellow.app";

	if (account) {
		return (
			<div className={styles.authPane}>
				<div className={cx(styles.whitelabelPane, styles[bgStyle])}>
					<div className={styles.shiftedUp} />

					<div className={cx(styles.workspace, styles.shiftedCenter)}>
						{renderAccountLogo()}
						<h2 data-test-id="preview-workspace-name">{account.name}</h2>
						<div data-test-id="preview-workspace-subdomain" className={styles.workspaceDomain}>
							{account.subdomain}
							{rootDomain}
						</div>
					</div>

					<div className={styles.shiftedDown}>
						{(invite || inviteLink) && !!account.teammates && (
							<div className={styles.shiftedDown}>
								<TalkingHeads teammates={account.teammates} />
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}

	const wordmark = <FellowWordmark className={styles.wordMark} />;
	return (
		<div className={styles.authPane}>
			<div className={cx(styles.whitelabelPane, styles[bgStyle])}>
				<div className={styles.shiftedUp} />
				<div className={cx(styles.shiftedCenter, styles.whitelabelWrapper)}>
					<h2>Welcome to</h2>
					{wordmark}
				</div>
				<div className={styles.shiftedDown} />
			</div>
		</div>
	);
}
